/*
   Copyright 2024, Guillermo Vega-Gorgojo
   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at
       http://www.apache.org/licenses/LICENSE-2.0
   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/
import config from '../data/config.json';
import dict from '../data/dictionary.json';
import { getLiteral } from '../modules/util.js';

/*********************
*** TEMPLATES FILE ***
**********************/
let urlLogo;
let cardTemplate;
let filtroTaxonesTemplate;
let taxonesSubheadingTemplate;
let sugeTaxonesTemplate;
let taxonesBlockTemplate;
let sugeLugaresTemplate;
let filterPlotModalTemplate;
let footerFilterPlot;
let taxonModalTemplate;
let layerGroupTemplate;
let provPopupTemplate;
let patchPopupTemplate;
let plotPopupTemplate;
let treePopupTemplate;
let downloadTemplateBody;
let downloadingTemplateBody;
let footerDescargaDatos;
let footerDescargando;
let footerDescargaDatosExito;
let spinnerTemplate;
let navbarTemplate;
let plotDashboardTemplate;
let coloresIfnTemplate;
let alertQuestionnaireTemplate;

let urlImagesLayers = [
	new URL('../images/default.png', import.meta.url),
	new URL('../images/satellite.png', import.meta.url),
	new URL('../images/plots.png', import.meta.url),
	new URL('../images/icon.png', import.meta.url),
	new URL('../images/patches.png', import.meta.url),
	new URL('../images/regions.png', import.meta.url),
	new URL('../images/munis.png', import.meta.url)
];

function updateHTMLtemplates() {
	urlLogo = getLiteral(dict.local) === 'en'? new URL('../images/iconfull_en.png', import.meta.url) :
		new URL('../images/iconfull_es.png', import.meta.url);
	
	cardTemplate = 
'<div id="tarjeta" class="card-body mitarjeta p-1" > \
	<div class="d-flex flex-row"> \
		<div class="dropdown"> \
			<button id ="bot_inicio" class="btn btn-outline-secondary" type="button" title="'+getLiteral(dict.menu)+'" \
				data-bs-toggle="dropdown" aria-expanded="false"><i class="bi bi-list"></i> \
			</button> \
			<ul class="dropdown-menu"> \
				<li><a id="tarjeta-home" class="dropdown-item home" href="#">'+getLiteral(dict.ttHome)+'</a></li> \
			    <li><hr class="dropdown-divider"></li> \
			    <li><a class="dropdown-item lang" tag="en" href="#">🇬🇧 EN</a></li> \
				<li><a class="dropdown-item lang" tag="es" href="#">🇪🇸 ES</a></li> \
			</ul> \
		</div> \
		<div class="btn-group"> \
			<button id="bot_taxones" class="text-nowrap btn btn-outline-secondary ms-sm-2 ms-1" type="button" disabled> \
				'+getLiteral(dict.taxonfilter)+'</button> \
			<input id="mapchecknomci" type="checkbox" class="btn-check nomci" id="btn-check" autocomplete="off" {{#nomci}}checked{{/nomci}} > \
			<label id="bot_mapnomci" title="'+getLiteral(dict.nomci)+'" class="btn btn-outline-secondary" for="mapchecknomci"><i class="bi bi-mortarboard-fill"></i></label> \
		</div> \
		<div class="btn-group ifnradio ms-sm-2 ms-1" role="group" aria-label="'+getLiteral(dict.ifnversion)+'" title="'+getLiteral(dict.ifnversion)+'"> \
			<input type="radio" class="btn-check" name="ifnradio" id="ifn2" autocomplete="off"> \
			<label id="label-ifn2" class="btn btn-outline-secondary px-2" for="ifn2">'+getLiteral(dict.IFN2)+'</label> \
			<input type="radio" class="btn-check" name="ifnradio" id="ifn3" autocomplete="off"> \
			<label id="label-ifn3" class="btn btn-outline-secondary px-2" for="ifn3">'+getLiteral(dict.IFN3)+'</label> \
			<input type="radio" class="btn-check" name="ifnradio" id="ifn4" autocomplete="off" disabled> \
			<label id="label-ifn4" class="btn btn-outline-secondary px-2" for="ifn4">'+getLiteral(dict.IFN4)+'</label> \
		</div> \
		<div id="toggle_lugares" class="btn-group ms-sm-2 ms-1 d-none"> \
			<input id="in_bot_lugares" type="checkbox" class="btn-check" id="btn-check" autocomplete="off"> \
			<label id="lab_bot_lugares" title="'+getLiteral(dict.searchplace)+'" class="btn btn-outline-secondary" for="in_bot_lugares"><i class="bi bi-search"></i></label> \
		</div> \
	</div> \
	<div id="lugares_heading" class="list-group mt-1 d-none"> \
		<input id="in_lugares" autocomplete="off" type="search" class="form-control " \
			placeholder="'+getLiteral(dict.searchplace)+'" aria-label="'+getLiteral(dict.searchplace)+'"> \
	</div> \
	<div id="sugelugares" class="list-group mt-1 d-none"></div> \
	<div id="taxones_subheading"></div> \
	<div id="taxones_block" class="taxones_block list-group overflow-auto mt-1 d-none" style="max-height:50vh;"></div> \
	<div id="plantae" class="d-flex align-items-center border border-secondary d-none rounded mt-1" style="background-color: '+ config.colores[0][1] +';"> \
		<div id="lab_plantae" class="ms-2"><i>Plantae</i></div> \
		<div class="ms-auto"> \
			<button id="filter-plantae" class="btn btn-sm {{#noplots}}d-none{{/noplots}}" type="button" turi="'+ config.treeUri +'"> \
				<i class="bi bi-filter-circle{{#plantaeUnset}}-fill{{/plantaeUnset}}"></i> \
			</button> \
		</div> \
		<div class="me-2"> \
			<button class="btn btn-sm info_taxon" type="button" turi="' + config.txPlantae + '" > \
				<i class="bi bi-info-circle-fill"></i> \
			</button> \
		</div> \
	</div> \
	<div id="filtros_taxon" class="mt-1 d-none"></div> \
	<div id="mibarradiv" class="progress mt-1 d-none" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"> \
        <div id="mibarra" class="progress-bar progress-bar-striped progress-bar-animated bg-secondary" style="width: 0%" >0%</div> \
        <div id="mibarra_loading" class="text-center text-dark" style="width: 100%">'+getLiteral(dict.loadingdata)+'</div> \
    </div> \
</div>';


	filtroTaxonesTemplate =
	'{{#.}} \
		<div class="d-flex align-items-center border border-secondary rounded div_filtro_taxon" style="background-color: {{color}};"> \
			<div class="ms-2">{{{textoFiltroTaxon}}}</div> \
			<div class="ms-auto"> \
				<button class="btn btn-sm tune_filter_taxon {{#noplots}}d-none{{/noplots}}" type="button" turi="{{{turi}}}" > \
					<i class="bi bi-filter-circle{{#filterUnset}}-fill{{/filterUnset}}"></i> \
				</button> \
			</div> \
			<div> \
				<button class="btn btn-sm info_taxon {{^info}}d-none{{/info}}" type="button" turi="{{{turi}}}" > \
					<i class="bi bi-info-circle-fill"></i> \
				</button> \
			</div> \
			<div class="me-1"> \
				<button class="btn btn-sm color_filtro" type="button" data-bs-toggle="dropdown" aria-expanded="false"> \
					<i class="bi bi-droplet-fill"></i> \
				</button> \
				<ul id="ul_colores{{ind}}" class="dropdown-menu" aria-labelledby="dropdownMenu"> \
					{{#colores}} \
						<li><a class="dropdown-item color_taxon" href="#" ind="{{ind}}" cind="{{cind}}">{{label}}</a></li> \
					{{/colores}} \
				</ul> \
			</div> \
			<div class="me-2 pb-1 quitar_taxon" ind="{{ind}}"> \
				<button type="button" class="btn-close" aria-label="Close"></button> \
			</div> \
		</div> \
	{{/.}}';
	

	taxonesSubheadingTemplate = 
	'{{#activar}} \
		<input id="in_taxon" autocomplete="off" type="search" class="form-control my-1" \
			 placeholder="'+getLiteral(dict.searchtaxon)+'" aria-label="'+getLiteral(dict.searchtaxon)+'"> \
	{{/activar}} \
	<div id="sugetaxones" class="list-group"></div>';


	sugeTaxonesTemplate = 
	'{{#sugerencias}} \
		<button class="list-group-item list-group-item-action bot_suge_taxon" type="button" spuri="{{uri}}"> \
			{{#nc}}<i>{{/nc}}{{{labelshown}}}{{#nc}}</i>{{/nc}}<span class="badge rounded-pill text-bg-secondary float-end me-0">{{nindivs}} '+getLiteral(dict.treeInitial)+'</span> \
		</button> \
	{{/sugerencias}} \
	{{#nosugerencias}} \
		<button type="button" class="list-group-item list-group-item-action py-2 bot_suge_taxon" disabled>'+getLiteral(dict.notaxonfound)+'</button> \
	{{/nosugerencias}}';	
	/*
	'{{#sugerencias}} \
		<button class="list-group-item list-group-item-action bot_suge_taxon" type="button" spuri="{{uri}}"> \
			{{#nc}}<i>{{/nc}}{{{labelshown}}}{{#nc}}</i>{{/nc}}<span class="badge rounded-pill text-bg-secondary float-end me-0">{{nclasses}} S</span> \
			<span class="badge rounded-pill text-bg-secondary float-end me-1">{{nindivs}}</span> \
		</button> \
	{{/sugerencias}} \
	{{#nosugerencias}} \
		<button type="button" class="list-group-item list-group-item-action py-2 bot_suge_taxon" disabled>'+getLiteral(dict.notaxonfound)+'</button> \
	{{/nosugerencias}}';*/


	taxonesBlockTemplate = 
	'{{#.}} \
		<div class="{{^esconder}}d-flex {{/esconder}}bd-highlight border-bottom border-left border-right taxon {{#esconder}}d-none{{/esconder}}" indice="{{indice}}"> \
			{{#botonesconder}} \
				<div><span>{{{indentspace}}}</span><span><button type="button" class="btn btn-outline-secondary btn-sm showmore">'+getLiteral(dict.showmore)+'</button></span></div> \
			{{/botonesconder}} \
			{{^botonesconder}} \
				<div class="flex-grow-1"> \
					<button class="list-group-item list-group-item-action border-0 bot_sel_taxon" type="button" spuri="{{uri}}"> \
						{{{indentspace}}}{{#nc}}<i>{{/nc}}{{label}}{{#nc}}</i>{{/nc}} \
						<span class="badge rounded-pill text-bg-secondary float-end me-0">{{nindivs}} '+getLiteral(dict.treeInitial)+'</span> \
					</button> \
				</div> \
				<div class="p-1"> \
					<button class="btn btn-outline-secondary btn-sm bot_expandir_taxon {{#nosubclasses}}invisible{{/nosubclasses}}" \
						type="button" data-placement="top"><i class="bi bi-chevron-right"></i> \
					</button> \
				</div> \
			{{/botonesconder}} \
		</div> \
	{{/.}}';	
	/*
	'{{#.}} \
		<div class="{{^esconder}}d-flex {{/esconder}}bd-highlight border-bottom border-left border-right taxon {{#esconder}}d-none{{/esconder}}" indice="{{indice}}"> \
			{{#botonesconder}} \
				<div><span>{{{indentspace}}}</span><span><button type="button" class="btn btn-outline-secondary btn-sm showmore">'+getLiteral(dict.showmore)+'</button></span></div> \
			{{/botonesconder}} \
			{{^botonesconder}} \
				<div class="flex-grow-1"> \
					<button class="list-group-item list-group-item-action border-0 bot_sel_taxon" type="button" spuri="{{uri}}"> \
						{{{indentspace}}}{{#nc}}<i>{{/nc}}{{label}}{{#nc}}</i>{{/nc}} \
						<span class="badge rounded-pill text-bg-secondary float-end me-0">{{nclasses}} S</span> \
						<span class="badge rounded-pill text-bg-secondary float-end me-1">{{nindivs}}</span> \
					</button> \
				</div> \
				<div class="p-1"> \
					<button class="btn btn-outline-secondary btn-sm bot_expandir_taxon {{#nosubclasses}}invisible{{/nosubclasses}}" \
						type="button" data-placement="top"><i class="bi bi-chevron-right"></i> \
					</button> \
				</div> \
			{{/botonesconder}} \
		</div> \
	{{/.}}';*/


	sugeLugaresTemplate = 
	'{{#sugerencias}} \
		<button type="button" class="list-group-item list-group-item-action py-2 bot_suge_lugar" id="{{id}}">{{{name}}}</button> \
	{{/sugerencias}} \
	{{#nosugerencias}} \
		<button type="button" class="list-group-item list-group-item-action py-2" disabled>'+getLiteral(dict.noplacesfound)+'</button> \
	{{/nosugerencias}}';
	
	
	filterPlotModalTemplate = 
	'<div class="container-fluid"> \
		<h5>{{{txname}}}</h5> \
		<div class="input-group mt-1"> \
			<input id="nt-min" type="number" class="form-control w-25" max="'+config.maxValuesPlot.nt+'" min="0" value="{{ntmin}}"> \
			<span class="input-group-text w-50 d-flex justify-content-center">{{{numbertreesHA}}}</span> \
			<input id="nt-max" type="number" class="form-control w-25" max="'+config.maxValuesPlot.nt+'" min="0" value="{{ntmax}}"> \
		</div> \
		<div id="nt" class="uislider mt-1"></div> \
		<div class="input-group mt-4"> \
			<input id="ba-min" type="number" class="form-control w-25" max="'+config.maxValuesPlot.ba+'" min="0" value="{{bamin}}"> \
			<span class="input-group-text w-50 d-flex justify-content-center">{{{basalareaM2HA}}}</span> \
			<input id="ba-max" type="number" class="form-control w-25" max="'+config.maxValuesPlot.ba+'" min="0" value="{{bamax}}"> \
		</div> \
		<div id="ba" class="uislider mt-1"></div> \
		<div class="input-group mt-4"> \
			<input id="vwb-min" type="number" class="form-control w-25" max="'+config.maxValuesPlot.vwb+'" min="0" value="{{vwbmin}}"> \
			<span class="input-group-text w-50 d-flex justify-content-center">{{{volumewithbarkM3HA}}}</span> \
			<input id="vwb-max" type="number" class="form-control w-25" max="'+config.maxValuesPlot.vwb+'" min="0" value="{{vwbmax}}"> \
		</div> \
		<div id="vwb" class="uislider mt-1"></div> \
		<div class="input-group mt-4"> \
			<input id="vwob-min" type="number" class="form-control w-25" max="'+config.maxValuesPlot.vwob+'" min="0" value="{{vwobmin}}"> \
			<span class="input-group-text w-50 d-flex justify-content-center">{{{volumewithoutbarkM3HA}}}</span> \
			<input id="vwob-max" type="number" class="form-control w-25" max="'+config.maxValuesPlot.vwob+'" min="0" value="{{vwobmax}}"> \
		</div> \
		<div id="vwob" class="uislider mt-1"></div> \
	</div>';/*
	'<div class="container-fluid"> \
		<h5>{{{txname}}}</h5> \
		<div class="input-group mt-1"> \
			<input id="nt-min" type="number" class="form-control w-25" max="'+config.maxValuesPlot.nt+'" min="0" value="{{ntmin}}"> \
			<span class="input-group-text w-50 d-flex justify-content-center">'+getLiteral(dict.numbertreesHA)+'</span> \
			<input id="nt-max" type="number" class="form-control w-25" max="'+config.maxValuesPlot.nt+'" min="0" value="{{ntmax}}"> \
		</div> \
		<div id="nt" class="uislider mt-1"></div> \
		<div class="input-group mt-4"> \
			<input id="ba-min" type="number" class="form-control w-25" max="'+config.maxValuesPlot.ba+'" min="0" value="{{bamin}}"> \
			<span class="input-group-text w-50 d-flex justify-content-center">'+getLiteral(dict.basalareaM2HA)+'</span> \
			<input id="ba-max" type="number" class="form-control w-25" max="'+config.maxValuesPlot.ba+'" min="0" value="{{bamax}}"> \
		</div> \
		<div id="ba" class="uislider mt-1"></div> \
		<div class="input-group mt-4"> \
			<input id="vwb-min" type="number" class="form-control w-25" max="'+config.maxValuesPlot.vwb+'" min="0" value="{{vwbmin}}"> \
			<span class="input-group-text w-50 d-flex justify-content-center">'+getLiteral(dict.volumewithbarkM3HA)+'</span> \
			<input id="vwb-max" type="number" class="form-control w-25" max="'+config.maxValuesPlot.vwb+'" min="0" value="{{vwbmax}}"> \
		</div> \
		<div id="vwb" class="uislider mt-1"></div> \
		<div class="input-group mt-4"> \
			<input id="vwob-min" type="number" class="form-control w-25" max="'+config.maxValuesPlot.vwob+'" min="0" value="{{vwobmin}}"> \
			<span class="input-group-text w-50 d-flex justify-content-center">'+getLiteral(dict.volumewithoutbarkM3HA)+'</span> \
			<input id="vwob-max" type="number" class="form-control w-25" max="'+config.maxValuesPlot.vwob+'" min="0" value="{{vwobmax}}"> \
		</div> \
		<div id="vwob" class="uislider mt-1"></div> \
	</div>';*/
	footerFilterPlot = 
	'<button id="resetFilter" type="button" class="btn btn-secondary" \
			data-bs-dismiss="modal">'+getLiteral(dict.resetfilter)+'</button> \
		<button id="applyFilter" type="button" class="ms-auto btn btn-primary" \
			data-bs-dismiss="modal" aria-label="Apply filter">'+getLiteral(dict.applyfilter)+'</button>';
	/*
	filterPlotModalTemplate = 
	'<div class="container-fluid"> \
		<h5>{{{txname}}}</h5> \
		<div class="d-flex justify-content-between"> \
			<span>'+getLiteral(dict.numbertreesHA)+'</span> \
			<span id="nt-range"></span> \
		</div> \
		<div id="nt" class="uislider mt-2"></div> \
		<div class="d-flex justify-content-between mt-3"> \
			<span>'+getLiteral(dict.basalareaM2HA)+'</span> \
			<span id="ba-range"></span> \
		</div> \
		<div id="ba" class="uislider mt-2"></div> \
		<div class="d-flex justify-content-between mt-3"> \
			<span>'+getLiteral(dict.volumewithbarkM3HA)+'</span> \
			<span id="vwb-range"></span> \
		</div> \
		<div id="vwb" class="uislider mt-2"></div> \
		<div class="d-flex justify-content-between mt-3"> \
			<span>'+getLiteral(dict.volumewithoutbarkM3HA)+'</span> \
			<span id="vwob-range"></span> \
		</div> \
		<div id="vwob" class="uislider mt-2"></div> \
		<!--div class="d-flex justify-content-between mt-3"> \
			<span>'+getLiteral(dict.sampledtrees)+'</span> \
			<span id="sampledTrees-range"></span> \
		</div> \
		<div id="sampledTrees" class="uislider mt-2"></div--> \
	</div>';
	footerFilterPlot = 
	'<button id="applyFilter" type="button" class="btn btn-primary" \
			data-bs-dismiss="modal" aria-label="Apply filter">'+getLiteral(dict.applyfilter)+'</button>';*/
	

	taxonModalTemplate =
	'<div class="container-fluid"> \
		{{#hayimagen}} \
			<div class="row"> \
				<div class="col-sm-5"> \
		{{/hayimagen}} \
					<h5 class="text-muted">{{tipo}}</h5> \
		{{#hayimagen}} \
			{{^multimages}} \
					<img class="img-fluid mt-1 mb-2" src="{{{image}}}"> \
			{{/multimages}} \
			{{#multimages}} \
				<div id="carouselPopupTaxon" class="carousel slide" data-bs-ride="carousel"> \
					<div class="carousel-inner"> \
						{{#image}} \
							<div class="carousel-item {{#active}}active{{/active}}"> \
								<img src="{{{src}}}" > \
							</div> \
						{{/image}} \
					</div> \
					<button class="carousel-control-prev" type="button" data-bs-target="#carouselPopupTaxon" data-bs-slide="prev"> \
						<span class="carousel-control-prev-icon" aria-hidden="true"></span> \
						<span class="visually-hidden">Previous</span> \
					</button> \
					<button class="carousel-control-next" type="button" data-bs-target="#carouselPopupTaxon" data-bs-slide="next"> \
						<span class="carousel-control-next-icon" aria-hidden="true"></span> \
						<span class="visually-hidden">Next</span> \
					</button>   \
				</div> \
			{{/multimages}} \
				</div> \
				<div class="col-sm-7"> \
		{{/hayimagen}} \
					{{#resumen}} \
						<p>{{resumen}}</p> \
					{{/resumen}} \
					{{#gbifPage}} \
						<a href="{{{.}}}" target="_blank" \
							class="btn btn-secondary btn-sm mb-1">GBIF</a> \
					{{/gbifPage}} \
					{{#wikidataPage}} \
						<a href="{{{.}}}" target="_blank" \
							class="btn btn-secondary btn-sm mb-1">Wikidata</a> \
					{{/wikidataPage}} \
					{{#wikipediaPage}} \
						<a href="{{{.}}}" target="_blank" \
							class="btn btn-secondary btn-sm mb-1">Wikipedia</a> \
					{{/wikipediaPage}} \
					{{#wikispeciesPage}} \
						<a href="{{{.}}}" target="_blank" \
							class="btn btn-secondary btn-sm mb-1">WikiSpecies</a> \
					{{/wikispeciesPage}} \
		{{#hayimagen}} \
				</div> \
			</div> \
		{{/hayimagen}} \
	</div>';
		
	provPopupTemplate =
	'<div class="m-0 p-0"> \
		<strong>{{prov}}</strong> <span class="fw-light">({{{source}}})</span> \
		<br><span class="fw-light">{{type}}</span> \
		{{#dataCapture}} \
			<br><span class="fw-light">{{dataCapture}}</span> \
		{{/dataCapture}} \
		{{#notabla}} \
			<div> \
				{{#rows}} \
					<br><span class="fw-normal">{{{head}}}:  {{#els}}{{{.}}}{{/els}}</span> \
				{{/rows}} \
			</div> \
		{{/notabla}} \
		{{^notabla}} \
			<table class="table table-borderless table-sm m-0"> \
				<thead> \
					<tr> \
						{{#head}} \
							{{{.}}} \
						{{/head}} \
					</tr> \
				</thead> \
				<tbody> \
					{{#rows}} \
						<tr> \
							<th scope="row">{{{head}}}</th> \
							{{#els}} \
								<td class="text-end">{{{.}}}</td> \
							{{/els}} \
						</tr> \
					{{/rows}} \
				</tbody> \
			</table> \
		{{/notabla}} \
	</div>';
	
	patchPopupTemplate =
	'<div iri="{{{iri}}}" class="m-0 p-0 popup patch"> \
		<strong>{{patch}}</strong> <span class="fw-light">({{{source}}})</span> \
		{{#prov}} \
			<br><span class="fw-light">{{.}}</span> \
		{{/prov}} \
		{{#dataCapture}} \
			<br><span class="fw-light">{{.}}</span> \
		{{/dataCapture}} \
		<br><br><span class="fw-normal">{{area}} \
		{{#haySoilUses}} \
			<br>'+ getLiteral(dict.soiluse) + ': \
			{{#soilUses}}{{{.}}}{{/soilUses}} \
		{{/haySoilUses}} \
		{{#soilUse}} \
			<br>{{{.}}} \
		{{/soilUse}} \
		{{#canopyCover}} \
			<br>{{{.}}} \
		{{/canopyCover}} \
		{{#hayInfoSpecies}} \
			<br>'+ getLiteral(dict.speciesinfo) + ': \
			{{#infoSpecies}}{{{.}}}{{/infoSpecies}} \
		{{/hayInfoSpecies}}</span> \
	</div>';
	
	plotPopupTemplate =
	'<div iri="{{{piri}}}" class="m-0 p-0 popup plot"> \
		<strong>{{plot}}</strong> <span class="fw-light">({{{source}}})</span> \
		{{#prov}} \
			<br><span class="fw-light">{{.}}</span> \
		{{/prov}} \
		{{#dataCapture}} \
			<br><span class="fw-light">{{.}}</span> \
		{{/dataCapture}} \
		{{#otherInvs}} \
			<br><span class="fw-light">{{.}}</span> \
		{{/otherInvs}} \
		{{#notreedata}} \
			<p class="fw-medium text-danger text-center">'+getLiteral(dict.notreedata)+'</p> \
		{{/notreedata}} \
		{{^notreedata}} \
			{{#notabla}} \
				<div> \
					{{#rows}} \
						<br><span class="fw-normal">{{{head}}}:  {{#els}}{{{.}}}{{/els}}</span> \
					{{/rows}} \
				</div> \
			{{/notabla}} \
			{{^notabla}} \
				<table class="table table-borderless table-sm m-0"> \
					<thead> \
						<tr> \
							{{#head}} \
								{{{.}}} \
							{{/head}} \
						</tr> \
					</thead> \
					<tbody> \
						{{#rows}} \
							<tr> \
								<th scope="row">{{{head}}}</th> \
								{{#els}} \
									<td class="text-end">{{{.}}}</td> \
								{{/els}} \
							</tr> \
						{{/rows}} \
					</tbody> \
				</table> \
			{{/notabla}} \
			<br> \
		{{/notreedata}} \
		<div style="display: flex; justify-content: center;"> \
			<button iri="{{{piri}}}" {{#ifn2}}ifn2="true"{{/ifn2}} {{#ifn3}}ifn3="true"{{/ifn3}} class="plot btn btn-primary" type="button">'+getLiteral(dict.showdashboard)+'</button> \
		</div> \
	</div>';
// <br><i>'+getLiteral(dict.clickzoomin)+'</i> \
	
		
	treePopupTemplate =
	'<div class="m-0 p-0"> \
		{{#notabla}} \
			<strong>{{tree}}</strong> <span class="fw-light">({{{source}}})</span> \
			{{#dataCapture}} \
				<br><span class="fw-light">{{.}}</span> \
			{{/dataCapture}} \
			<div> \
				{{#rows}} \
					<br><span class="fw-normal">{{{head}}}:  {{#els}}{{{.}}}{{/els}}</span> \
				{{/rows}} \
			</div> \
		{{/notabla}} \
		{{^notabla}} \
			<table class="table table-borderless table-sm m-0"> \
				<thead> \
					<tr> \
						{{#head}} \
							{{{.}}} \
						{{/head}} \
					</tr> \
				</thead> \
				<tbody> \
					{{#rows}} \
						<tr> \
							<th scope="row">{{{head}}}</th> \
							{{#els}} \
								<td class="text-end">{{{.}}}</td> \
							{{/els}} \
						</tr> \
					{{/rows}} \
				</tbody> \
			</table> \
		{{/notabla}} \
	</div>';

	layerGroupTemplate = // sin municipios
	'<div class="collapse card p-0" id="sel-layers"> \
		<div class="card-body p-1"> \
			<div class="row g-0"> \
				<div class="col-8 text-center"> \
					<h6 class="card-title m-1">' + getLiteral(dict.mapType) + '</h6> \
				</div> \
				<div class="col-4 text-center"> \
					<h6 class="card-title m-1">' + getLiteral(dict.IFN) + '</h6> \
				</div> \
			</div> \
			<div class="row input-group text-center justify-content-center g-0"> \
				<div class="col form-check px-1 px-sm-2"> \
					<input class="btn-check micheckmapa" type="radio" name="mapType" id="map-type-default" value="default"> \
					<label class="btn" for="map-type-default"> \
						<img src="'+urlImagesLayers[0]+'" class="img-fluid rounded" alt="..."> \
					</label> \
					<div class="text-nowrap">' + getLiteral(dict.default) + '</div> \
				</div> \
				<div class="col form-check px-1 px-sm-2"> \
					<input class="btn-check micheckmapa" type="radio" name="mapType" id="map-type-satellite" value="satellite"> \
					<label class="btn" for="map-type-satellite"> \
						<img src="'+urlImagesLayers[1]+'" class="img-fluid rounded" alt="..."> \
					</label> \
					<div class="text-nowrap">' + getLiteral(dict.satellite) + '</div> \
				</div> \
				<div class="col-auto px-1 px-sm-2"> \
					<div class="vertical-line"></div> \
				</div> \
				<div class="col px-1 px-sm-2"> \
					<input type="checkbox" class="btn-check micheckmapa" id="check-plots" autocomplete="off"> \
					<label class="btn" for="check-plots"> \
						<img src="'+urlImagesLayers[2]+'" class="img-fluid rounded" alt="..."> \
					</label> \
					<div class="text-nowrap">' + getLiteral(dict.plots) + '</div> \
				</div> \
			</div> \
			<hr class="my-1"> \
			<div class="row g-0 mt-1"> \
				<div class="col text-center"> \
					<h6 class="card-title m-1">' + getLiteral(dict.mapDetails) + '</h6> \
				</div> \
			</div> \
			<div class="row input-group text-center justify-content-center g-0"> \
				<div class="col form-check px-1 px-sm-2"> \
					<input class="btn-check micheckmapa" type="radio" name="mapDetails" id="map-details-auto" value="auto"> \
					<label class="btn" for="map-details-auto"> \
						<img src="'+urlImagesLayers[3]+'" class="img-fluid rounded" alt="..."> \
					</label> \
					<div class="text-nowrap">Auto</div> \
				</div> \
				<div class="col form-check px-1 px-sm-2"> \
					<input class="btn-check micheckmapa" type="radio" name="mapDetails" id="map-details-patches" value="patches"> \
					<label class="btn" for="map-details-patches"> \
						<img src="'+urlImagesLayers[4]+'" class="img-fluid rounded" alt="..."> \
					</label> \
					<div class="text-nowrap">' + getLiteral(dict.patches) + '</div> \
				</div> \
				<div class="col form-check px-1 px-sm-2"> \
					<input class="btn-check micheckmapa" type="radio" name="mapDetails" id="map-details-regions" value="regions"> \
					<label class="btn" for="map-details-regions"> \
						<img src="'+urlImagesLayers[5]+'" class="img-fluid rounded" alt="..."> \
					</label> \
					<div class="text-nowrap">' + getLiteral(dict.regions) + '</div> \
				</div> \
				<!--div class="col form-check px-0 px-sm-2"> \
					<input class="btn-check micheckmapa" type="radio" name="mapDetails" id="map-details-munis" value="munis"> \
					<label class="btn" for="map-details-munis"> \
						<img src="'+urlImagesLayers[6]+'" class="img-fluid rounded" alt="..."> \
					</label> \
					<div class="text-nowrap">' + getLiteral(dict.municipalities) + '</div> \
				</div--> \
			</div> \
		</div> \
	</div> \
	<div class="group mt-auto ms-auto" style="border: 2px solid #0003; border-radius: 4px;"> \
		<a class="layer" title="' + getLiteral(dict.selectLayer) + '" href="#sel-layers" role="button" \
				data-bs-toggle="collapse" aria-expanded="false" aria-controls="sel-layers"> \
			<span class="bi bi-layers-fill"></span> \
		</a> \
	</div>';

 /* CON municipios
	'<div class="collapse card p-0" id="sel-layers"> \
		<div class="card-body p-1"> \
			<div class="row g-0"> \
				<div class="col-8 text-center"> \
					<h6 class="card-title m-1">' + getLiteral(dict.mapType) + '</h6> \
				</div> \
				<div class="col-4 text-center"> \
					<h6 class="card-title m-1">IFN</h6> \
				</div> \
			</div> \
			<div class="row input-group text-center justify-content-center g-0"> \
				<div class="col form-check px-1 px-sm-2"> \
					<input class="btn-check micheckmapa" type="radio" name="mapType" id="map-type-default" value="default"> \
					<label class="btn" for="map-type-default"> \
						<img src="default.png" class="img-fluid rounded" alt="..."> \
					</label> \
					<div class="text-nowrap">' + getLiteral(dict.default) + '</div> \
				</div> \
				<div class="col form-check px-1 px-sm-2"> \
					<input class="btn-check micheckmapa" type="radio" name="mapType" id="map-type-satellite" value="satellite"> \
					<label class="btn" for="map-type-satellite"> \
						<img src="satellite.png" class="img-fluid rounded" alt="..."> \
					</label> \
					<div class="text-nowrap">' + getLiteral(dict.satellite) + '</div> \
				</div> \
				<div class="col-auto px-1 px-sm-2"> \
					<div class="vertical-line"></div> \
				</div> \
				<div class="col px-1 px-sm-2"> \
					<input type="checkbox" class="btn-check micheckmapa" id="check-plots" autocomplete="off"> \
					<label class="btn" for="check-plots"> \
						<img src="plots.png" class="img-fluid rounded" alt="..."> \
					</label> \
					<div class="text-nowrap">' + getLiteral(dict.plots) + '</div> \
				</div> \
			</div> \
			<hr class="my-1"> \
			<div class="row g-0 mt-1"> \
				<div class="col text-center"> \
					<h6 class="card-title m-1">' + getLiteral(dict.mapDetails) + '</h6> \
				</div> \
			</div> \
			<div class="row input-group text-center justify-content-center g-0"> \
				<div class="col form-check px-0 px-sm-2"> \
					<input class="btn-check micheckmapa" type="radio" name="mapDetails" id="map-details-auto" value="auto"> \
					<label class="btn" for="map-details-auto"> \
						<img src="icon.png" class="img-fluid rounded" alt="..."> \
					</label> \
					<div class="text-nowrap">Auto</div> \
				</div> \
				<div class="col form-check px-0 px-sm-2"> \
					<input class="btn-check micheckmapa" type="radio" name="mapDetails" id="map-details-patches" value="patches"> \
					<label class="btn" for="map-details-patches"> \
						<img src="patches.png" class="img-fluid rounded" alt="..."> \
					</label> \
					<div class="text-nowrap">' + getLiteral(dict.patches) + '</div> \
				</div> \
				<div class="col form-check px-0 px-sm-2"> \
					<input class="btn-check micheckmapa" type="radio" name="mapDetails" id="map-details-regions" value="regions"> \
					<label class="btn" for="map-details-regions"> \
						<img src="regions.png" class="img-fluid rounded" alt="..."> \
					</label> \
					<div class="text-nowrap">' + getLiteral(dict.regions) + '</div> \
				</div> \
				<div class="col form-check px-0 px-sm-2"> \
					<input class="btn-check micheckmapa" type="radio" name="mapDetails" id="map-details-munis" value="munis"> \
					<label class="btn" for="map-details-munis"> \
						<img src="munis.png" class="img-fluid rounded" alt="..."> \
					</label> \
					<div class="text-nowrap">' + getLiteral(dict.municipalities) + '</div> \
				</div> \
			</div> \
		</div> \
	</div> \
	<div class="group mt-auto ms-auto"> \
		<a class="layer" title="' + getLiteral(dict.selectLayer) + '" href="#sel-layers" role="button" \
				data-bs-toggle="collapse" aria-expanded="false" aria-controls="sel-layers"> \
			<span class="bi bi-layers-fill"></span> \
		</a> \
	</div>';*/

/* TODO: layerGroupTemplate PREVIO con municipios


	layerGroupTemplate =
	'<div class="collapse card p-0" id="sel-layers"> \
		<div class="card-body p-1"> \
			<div class="row g-0"> \
				<div class="col-9 text-center"> \
					<h6 class="card-title m-1">' + getLiteral(dict.mapType) + '</h6> \
				</div> \
				<div class="col-3 text-center"> \
					<h6 class="card-title m-1">IFN</h6> \
				</div> \
			</div> \
			<div class="input-group"> \
				<div class="row text-center"> \
					<div class="col form-check"> \
						<input class="btn-check micheckmapa" type="radio" name="mapType" id="map-type-default" value="default"> \
						<label class="btn" for="map-type-default"> \
							<img src="default.png" class="img-fluid rounded" alt="..."> \
						</label> \
						<div class="text-nowrap">' + getLiteral(dict.default) + '</div> \
					</div> \
					<div class="col form-check"> \
						<input class="btn-check micheckmapa" type="radio" name="mapType" id="map-type-satellite" value="satellite"> \
						<label class="btn" for="map-type-satellite"> \
							<img src="satellite.png" class="img-fluid rounded" alt="..."> \
						</label> \
						<div class="text-nowrap">' + getLiteral(dict.satellite) + '</div> \
					</div> \
					<div class="col-auto"> \
						<div class="vertical-line"></div> \
					</div> \
					<div class="col"> \
						<input type="checkbox" class="btn-check micheckmapa" id="check-plots" autocomplete="off"> \
						<label class="btn" for="check-plots"> \
							<img src="plots.png" class="img-fluid rounded" alt="..."> \
						</label> \
						<div class="text-nowrap">' + getLiteral(dict.plots) + '</div> \
					</div> \
				</div> \
			</div> \
			<hr class="my-1"> \
			<div class="row g-0 mt-2"> \
				<div class="col text-center"> \
					<h6 class="card-title">' + getLiteral(dict.mapDetails) + '</h6> \
				</div> \
			</div> \
			<div class="input-group"> \
				<div class="row text-center g-0"> \
					<div class="col form-check ps-1 ps-sm-2"> \
						<input class="btn-check micheckmapa" type="radio" name="mapDetails" id="map-details-auto" value="auto"> \
						<label class="btn" for="map-details-auto"> \
							<img src="icon.png" class="img-fluid rounded" alt="..."> \
						</label> \
						<div class="text-nowrap">Auto</div> \
					</div> \
					<div class="col form-check ps-1 ps-sm-2"> \
						<input class="btn-check micheckmapa" type="radio" name="mapDetails" id="map-details-patches" value="patches"> \
						<label class="btn" for="map-details-patches"> \
							<img src="patches.png" class="img-fluid rounded" alt="..."> \
						</label> \
						<div class="text-nowrap">' + getLiteral(dict.patches) + '</div> \
					</div> \
					<div class="col form-check ps-1 ps-sm-2"> \
						<input class="btn-check micheckmapa" type="radio" name="mapDetails" id="map-details-regions" value="regions"> \
						<label class="btn" for="map-details-regions"> \
							<img src="regions.png" class="img-fluid rounded" alt="..."> \
						</label> \
						<div class="text-nowrap">' + getLiteral(dict.regions) + '</div> \
					</div> \
					<div class="col form-check ps-1 ps-sm-2"> \
						<input class="btn-check micheckmapa" type="radio" name="mapDetails" id="map-details-munis" value="munis"> \
						<label class="btn" for="map-details-munis"> \
							<img src="munis.png" class="img-fluid rounded" alt="..."> \
						</label> \
						<div class="text-nowrap">' + getLiteral(dict.municipalities) + '</div> \
					</div> \
				</div> \
			</div> \
		</div> \
	</div> \
	<div class="group mt-auto ms-auto"> \
		<a class="layer" title="' + getLiteral(dict.selectLayer) + '" href="#sel-layers" role="button" \
				data-bs-toggle="collapse" aria-expanded="false" aria-controls="sel-layers"> \
			<span class="bi bi-layers-fill"></span> \
		</a> \
	</div>';
*/



	downloadTemplateBody =
	'<div> \
		{{#nodata}} \
			<p><strong>'+getLiteral(dict.downloadNothing)+'</strong></p> \
		{{/nodata}} \
		{{^nodata}} \
			<p>'+getLiteral(dict.downloadMessage)+'</p> \
			{{#inSpain}} \
			<div>'+getLiteral(dict.downloadIFN)+'</div> \
			<div class="btn-group" role="group" aria-label="Download IFN"> \
				<input class="btn-check check-ifn" type="checkbox" value="" id="checkIFN2"> \
				<label class="btn btn-outline-primary" for="checkIFN2">'+getLiteral(dict.IFN2)+'</label> \
				<input class="btn-check check-ifn" type="checkbox" value="" id="checkIFN3"> \
				<label class="btn btn-outline-primary" for="checkIFN3">'+getLiteral(dict.IFN3)+'</label> \
			</div> \
			<br><div id="downloadNoIFN"><strong>'+getLiteral(dict.downloadNoIFN)+'</strong></div> \
			<br> \
			{{/inSpain}} \
			<div>'+getLiteral(dict.downloadChoices)+'</div> \
			<div class="btn-group" role="group" aria-label="Download choices"> \
				{{#plotsAvailable}} \
				<input class="btn-check check-download plots" type="checkbox" value="" id="checkPlots"> \
				<label class="btn btn-outline-primary" for="checkPlots">'+getLiteral(dict.plots)+'</label> \
				<input class="btn-check check-download trees" type="checkbox" value="" id="checkTrees"> \
				<label class="btn btn-outline-primary" for="checkTrees">'+getLiteral(dict.trees)+'</label> \
				{{/plotsAvailable}} \
				<input class="btn-check check-download regions" type="checkbox" value="" id="checkRegions"> \
				<label class="btn btn-outline-primary" for="checkRegions">'+getLiteral(dict.regions)+'</label> \
				<input class="btn-check check-download patches" type="checkbox" value="" id="checkPatches"> \
				<label class="btn btn-outline-primary" for="checkPatches">'+getLiteral(dict.patches)+'</label> \
			</div> \
			<br><div id="downloadNothing"><strong>'+getLiteral(dict.downloadNothing)+'</strong></div> \
			<br><div>'+getLiteral(dict.downloadFormatChoose)+'</div> \
			<div class="btn-group" role="group" aria-label="Download IFN"> \
				<input type="radio" class="btn-check radio-format" name="format" id="GeoJSON" autocomplete="off"> \
				<label class="btn btn-outline-primary" for="GeoJSON">GeoJSON</label> \
				<input type="radio" class="btn-check radio-format" name="format" id="CSV" autocomplete="off"> \
				<label class="btn btn-outline-primary" for="CSV">CSV</label> \
				<input type="radio" class="btn-check radio-format" name="format" id="XLSX" autocomplete="off"> \
				<label class="btn btn-outline-primary" for="XLSX">XLSX</label> \
			</div> \
			<div id="downloadNoFormat"><strong>'+getLiteral(dict.downloadNoFormat)+'</strong></div> \
		{{/nodata}} \
	</div>';

	/*
	downloadTemplateBody =
	'<div> \
		<p>'+getLiteral(dict.downloadMessage)+'</p> \
		<span>'+getLiteral(dict.downloadChoices)+'</span> \
		{{#plotsAvailable}} \
		<div class="form-check"> \
			<input class="form-check-input check-download plots" type="checkbox" value="" id="checkPlots"> \
			<label class="form-check-label" for="checkPlots">'+getLiteral(dict.checkPlots)+'</label> \
		</div> \
		<div class="form-check"> \
			<input class="form-check-input check-download trees" type="checkbox" value="" id="checkTrees"> \
			<label class="form-check-label" for="checkTrees">'+getLiteral(dict.checkTrees)+'</label> \
		</div> \
		{{/plotsAvailable}} \
		<div class="form-check"> \
			<input class="form-check-input check-download regions" type="checkbox" value="" id="checkRegions"> \
			<label class="form-check-label" for="checkRegions">'+getLiteral(dict.checkRegions)+'</label> \
		</div> \
		<div class="form-check"> \
			<input class="form-check-input check-download patches" type="checkbox" value="" id="checkPatches"> \
			<label class="form-check-label" for="checkPatches">'+getLiteral(dict.checkPatches)+'</label> \
		</div> \
		<div id="downloadNothing"><strong>'+getLiteral(dict.downloadNothing)+'</strong></div> \
		<br><div>'+getLiteral(dict.downloadFormatChoose)+'</div> \
		<input type="radio" class="btn-check downloadRadio" name="format" id="GeoJSON" autocomplete="off"> \
		<label class="btn btn-outline-primary" for="GeoJSON">GeoJSON</label> \
		<input type="radio" class="btn-check downloadRadio" name="format" id="CSV" autocomplete="off"> \
		<label class="btn btn-outline-primary" for="CSV">CSV</label> \
		<div id="downloadNoFormat"><strong>'+getLiteral(dict.downloadNoFormat)+'</strong></div> \
	</div>';*/
	
	downloadingTemplateBody =
	'<div> \
		<div id="downloadingPlots" class="d-none"><i class="bi bi-arrow-right-circle"></i> \
			<span class="ms-1">'+ getLiteral(dict.downloadingPlots) +'</span> \
		</div> \
		<div id="plotsDownloaded" class="d-none"><i class="bi bi-check-lg"></i> \
			<span class="ms-1">'+ getLiteral(dict.plotsDownloaded) +'</span> \
		</div> \
		<div id="noPlotsDownloaded" class="d-none"><i class="bi bi-info-circle"></i> \
			<span class="ms-1">'+ getLiteral(dict.noPlotsDownloaded) +'</span> \
		</div> \
		<div id="downloadingTrees" class="d-none"><i class="bi bi-arrow-right-circle"></i> \
			<span class="ms-1">'+ getLiteral(dict.downloadingTrees) +'</span> \
		</div> \
		<div id="treesDownloaded" class="d-none"><i class="bi bi-check-lg"></i> \
			<span class="ms-1">'+ getLiteral(dict.treesDownloaded) +'</span> \
		</div> \
		<div id="noTreesDownloaded" class="d-none"><i class="bi bi-info-circle"></i> \
			<span class="ms-1">'+ getLiteral(dict.noTreesDownloaded) +'</span> \
		</div> \
		<div id="downloadingRegions" class="d-none"><i class="bi bi-arrow-right-circle"></i> \
			<span class="ms-1">'+ getLiteral(dict.downloadingRegions) +'</span> \
		</div> \
		<div id="regionsDownloaded" class="d-none"><i class="bi bi-check-lg"></i> \
			<span class="ms-1">'+ getLiteral(dict.regionsDownloaded) +'</span> \
		</div> \
		<div id="downloadingPatches" class="d-none"><i class="bi bi-arrow-right-circle"></i> \
			<span class="ms-1">'+ getLiteral(dict.downloadingPatches) +'</span> \
		</div> \
		<div id="patchesDownloaded" class="d-none"><i class="bi bi-check-lg"></i> \
			<span class="ms-1">'+ getLiteral(dict.patchesDownloaded) +'</span> \
		</div> \
		<div id="noPatchesDownloaded" class="d-none"><i class="bi bi-info-circle"></i> \
			<span class="ms-1">'+ getLiteral(dict.noPatchesDownloaded) +'</span> \
		</div> \
		<div id="mibarradescarga_div" class="progress my-1" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"> \
			<div id="mibarradescarga" class="progress-bar progress-bar-striped progress-bar-animated bg-primary" style="width: 0%" >0%</div> \
		</div> \
		<div id="downloadSuccess" class="d-none"><br><strong>'+getLiteral(dict.downloadSuccess)+'</strong></div> \
	</div>';
	
	footerDescargaDatos = 
	'<button id="downloadClose" type="button" class="btn btn-secondary" \
			data-bs-dismiss="modal" aria-label="Close">'+getLiteral(dict.cancel)+'</button> \
	<button id="downloadData" type="button" class="btn btn-primary" disabled>'+getLiteral(dict.download)+'</button>';
	
	footerDescargando = 
	'<button id="downloadCancel" type="button" class="btn btn-secondary" \
			data-bs-dismiss="modal" aria-label="Close">'+getLiteral(dict.cancel)+'</button>';
	
	footerDescargaDatosExito = 
	'<button id="downloadClose" type="button" class="btn btn-primary" \
			data-bs-dismiss="modal" aria-label="Close">'+getLiteral(dict.close)+'</button>';


	spinnerTemplate =
	'<div class="d-flex flex-row bd-highlight m-5"> \
		<div class="p-3 bd-highlight"><div class="spinner-border" role="status" aria-hidden="true"></div></div> \
		<div class="ml-5 bd-highlight"><div><h3 id="titleSpinner">'+getLiteral(dict.spinnerLoading)+'</h3><p id="infoSpinner" class="font-weight-light">'+getLiteral(dict.spinnerInfo)+'</p></div></div> \
	</div>';
	
	
	navbarTemplate = 
	'<nav class="navbar navbar-expand-md" style="background-color: #DCEDC8;"> \
		<div class="container-fluid"> \
			<a class="navbar-brand d-none d-md-block" href="#"> \
				<img src="' + urlLogo + '" alt="Forest Explorer" height="40"> \
			</a> \
			<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation"> \
				<span class="navbar-toggler-icon"></span> \
			</button> \
			<div class="collapse navbar-collapse" id="navbarNav"> \
				<ul class="navbar-nav"> \
					<li class="nav-item"> \
						<a class="nav-link home" href="#">'+getLiteral(dict.ttHome)+'</a> \
					</li> \
					<li class="nav-item"> \
						<a class="nav-link map" href="#">'+getLiteral(dict.map)+'</a> \
					</li> \
					<li class="nav-item dropdown"> \
						<a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">'
							+getLiteral(dict.flaglang)+'</a> \
						<ul class="dropdown-menu"> \
							<li><a class="dropdown-item lang" tag="en" href="#">🇬🇧 EN</a></li> \
							<li><a class="dropdown-item lang" tag="es" href="#">🇪🇸 ES</a></li> \
						</ul> \
					</li> \
					<li class="nav-item"> \
						<input id="plotchecknomci" type="checkbox" class="btn-check nomci" id="btn-check" autocomplete="off" {{#nomci}}checked{{/nomci}} > \
						<label id="bot_plotnomci" title="'+getLiteral(dict.nomci)+'" class="btn btn-outline-secondary" for="plotchecknomci"><i class="bi bi-mortarboard-fill"></i></label> \
					</li> \
				</ul> \
			</div> \
			<a class="navbar-brand d-block d-md-none mx-auto" href="#"> \
				<img src="' + urlLogo + '" alt="Forest Explorer" height="28"> \
			</a> \
		</div> \
	</nav>';

					
	plotDashboardTemplate = navbarTemplate +
	'<div class="container pb-4"> \
		<div class="container-fluid"> \
			<div class="d-flex justify-content-center align-items-center mt-2 {{^ifnchecks}}d-none{{/ifnchecks}}"> \
				<div class="btn-group ifncheckplot" role="group" aria-label="'+getLiteral(dict.ifnversion)+'" title="'+getLiteral(dict.ifnversion)+'"> \
					{{#ifnchecks}} \
						{{#.}} \
							<input type="checkbox" class="btn-check check-ifn-dash" name="ifncheckplot" ifn="{{ifn}}" id="checkplot-{{ifn}}" autocomplete="off" {{#checked}}checked{{/checked}}> \
							<label class="btn btn-outline-secondary px-2" for="checkplot-{{ifn}}">{{ifnlab}}</label> \
						{{/.}} \
					{{/ifnchecks}} \
				</div> \
			</div> \
			<div class="row justify-content-lg-center mt-2 p-0"> \
				<div class="col-lg-9 p-0"> \
					<div class="card p-0"> \
						<div class="card-header p-0 m-0"> \
							<div class="row p-0 m-0"> \
								{{#ifnheads}} \
									{{#.}} \
										<div class="col-sm table-responsive m-0 p-1 p-sm-2"> \
											<table class="table table-borderless table-sm m-0"> \
												<thead> \
													<tr> \
														<th colspan="2" class="text-center rounded" style="background-color: {{titlecolor}};">{{{title}}}</td> \
													</tr> \
												</thead> \
												<tbody> \
													{{#rows}} \
														<tr class="align-middle"> \
															<th scope="row" style="background-color: transparent;">{{{head}}}</th> \
															<td style="background-color: transparent;">{{{value}}}</td> \
														</tr> \
													{{/rows}} \
												</tbody> \
											</table> \
										</div> \
									{{/.}} \
								{{/ifnheads}} \
							</div> \
						</div> \
						<div class="card-body p-0"> \
							{{#hayMapa}} \
							<div id="mapaparcela" style="height: 450px;"></div> \
							{{/hayMapa}} \
							{{^hayMapa}} \
							<h5 class="text-center m-3 text-danger">'+getLiteral(dict.noTreesInPlot)+'</h5> \
							{{/hayMapa}} \
						</div> \
					</div> \
				</div> \
			</div> \
			<div class="row justify-content-lg-center"> \
				<div class="col-lg-9 py-4 px-0"> \
					<!-- TABLA árboles --> \
					{{#hayMapa}} \
					<div class="dropdown d-flex justify-content-between"> \
						<h5>'+getLiteral(dict.treeData)+'</h5> \
						<button id="botonTablaArboles" class="btn btn-secondary" type="button" data-bs-toggle="collapse" \
							data-bs-target="#tablaArboles" aria-expanded="false" aria-controls="tablaArboles">'+getLiteral(dict.show)+'</button> \
					</div> \
					<div id="tablaArboles" class="collapse table-responsive"> \
						<table class="table table-sm table-striped table-hover m-0"> \
							<thead> \
								<tr> \
									{{#thead}} \
										{{{.}}} \
									{{/thead}} \
								</tr> \
								{{#haythead2}} \
								<tr> \
									{{#thead2}} \
										{{{.}}} \
									{{/thead2}} \
								</tr> \
								{{/haythead2}} \
							</thead> \
							<tbody> \
								{{#trows}} \
									<tr ind="{{ind}}"> \
										<!--th scope="row">{{{head}}}</th--> \
										{{#els}} \
											<td class="text-center">{{{.}}}</td> \
										{{/els}} \
									</tr> \
								{{/trows}} \
							</tbody> \
						</table> \
					</div> \
					{{/hayMapa}} \
					<!-- CANVAS infoSpeciesStock --> \
					{{#hayISS}} \
						{{#hayMapa}} \
						<hr> \
						{{/hayMapa}} \
						<div class="dropdown d-flex justify-content-between"> \
							<h5>'+getLiteral(dict.stockSpeciesInfo)+'</h5> \
							<button id="botonISS" class="btn btn-secondary" type="button" data-bs-toggle="collapse" \
								data-bs-target="#divISS" aria-expanded="true" aria-controls="divISS">'+getLiteral(dict.hide)+'</button> \
						</div> \
						<div id="divISS" class="collapse show mt-2"> \
							<div class="d-flex justify-content-between"> \
								<div class="btn-group radioISS" role="group" aria-label="'+getLiteral(dict.charttable)+'" title="'+getLiteral(dict.charttable)+'"> \
									<input type="radio" class="btn-check chart" name="radioISS" id="radioISS-chart" autocomplete="off" checked> \
									<label class="btn btn-outline-secondary" for="radioISS-chart"><i class="bi bi-bar-chart-fill"></i></label> \
									<input type="radio" class="btn-check table" name="radioISS" id="radioISS-table" autocomplete="off"> \
									<label class="btn btn-outline-secondary" for="radioISS-table"><i class="bi bi-table"></i></label> \
								</div> \
								<button id="botonInfoSpeciesStock" class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">'+getLiteral(dict.treedensity)+'</button> \
								<ul class="dropdown-menu"> \
									<li><a class="dropdown-item isstock" ind="0" href="#">'+getLiteral(dict.treedensity)+'</a></li> \
									<li><a class="dropdown-item isstock" ind="1" href="#">'+getLiteral(dict.basalarea)+'</a></li> \
									<li><a class="dropdown-item isstock" ind="2" href="#">'+getLiteral(dict.volumewithbark)+'</a></li> \
									<li><a class="dropdown-item isstock" ind="3" href="#">'+getLiteral(dict.volumewithoutbark)+'</a></li> \
								</ul> \
								<div></div> \
							</div> \
							<canvas id="speciesStockChart"></canvas> \
							<div id="tablaISS" class="d-none table-responsive"> \
								<table class="table table-sm table-striped m-0"> \
									<thead> \
										<tr> \
											{{#tisshead}} \
												{{{.}}} \
											{{/tisshead}} \
										</tr> \
										{{#haytisshead2}} \
										<tr> \
											{{#tisshead2}} \
												{{{.}}} \
											{{/tisshead2}} \
										</tr> \
										{{/haytisshead2}} \
									</thead> \
									<tbody> \
										{{#tissrows}} \
											<tr> \
												<th scope="row">{{{head}}}</th> \
												{{#els}} \
													<td class="text-center">{{{.}}}</td> \
												{{/els}} \
											</tr> \
										{{/tissrows}} \
									</tbody> \
								</table> \
							</div> \
						</div> \
					{{/hayISS}} \
					<!-- CANVAS infoSpeciesDC --> \
					{{#hayDC}} \
						{{#hayISS}} \
						<hr> \
						{{/hayISS}} \
						<div class="dropdown d-flex justify-content-between"> \
							<h5>'+getLiteral(dict.dcSpeciesInfo)+'</h5> \
							<button id="botonDC" class="btn btn-secondary" type="button" data-bs-toggle="collapse" \
								data-bs-target="#divDC" aria-expanded="true" aria-controls="divDC">'+getLiteral(dict.hide)+'</button> \
						</div> \
						<div id="divDC" class="collapse show mt-2"> \
							<div class="d-flex justify-content-between"> \
								<div class="btn-group radioDC" role="group" aria-label="'+getLiteral(dict.charttable)+'" title="'+getLiteral(dict.charttable)+'"> \
									<input type="radio" class="btn-check chart" name="radioDC" id="radioDC-chart" autocomplete="off" checked> \
									<label class="btn btn-outline-secondary" for="radioDC-chart"><i class="bi bi-bar-chart-fill"></i></label> \
									<input type="radio" class="btn-check table" name="radioDC" id="radioDC-table" autocomplete="off"> \
									<label class="btn btn-outline-secondary" for="radioDC-table"><i class="bi bi-table"></i></label> \
								</div> \
								<button id="botonMedidaDC" ind="0" class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">'+getLiteral(dict.treedensity)+'</button> \
								<ul class="dropdown-menu"> \
									<li><a class="dropdown-item idcmed" ind="0" href="#">'+getLiteral(dict.treedensity)+'</a></li> \
									<li><a class="dropdown-item idcmed" ind="1" href="#">'+getLiteral(dict.basalarea)+'</a></li> \
									<li><a class="dropdown-item idcmed" ind="2" href="#">'+getLiteral(dict.volumewithbark)+'</a></li> \
									<li><a class="dropdown-item idcmed" ind="3" href="#">'+getLiteral(dict.volumewithoutbark)+'</a></li> \
								</ul> \
								<div></div> \
							</div> \
							<canvas id="speciesDCChart"></canvas> \
							<div id="tablaDC" class="d-none table-responsive"> \
								<table class="table table-sm m-0"> \
									<thead> \
										<tr> \
											{{#tdchead}} \
												{{{.}}} \
											{{/tdchead}} \
										</tr> \
										{{#haytdchead2}} \
										<tr> \
											{{#tdchead2}} \
												{{{.}}} \
											{{/tdchead2}} \
										</tr> \
										{{/haytdchead2}} \
									</thead> \
									<tbody> \
										{{#tdcrows}} \
											{{{.}}} \
										{{/tdcrows}} \
									</tbody> \
								</table> \
							</div> \
						</div> \
					{{/hayDC}} \
					<!-- BACK AND DELETE BUTTONS --> \
					<div class="float-end mt-4"> \
						<button type="button" class="btn btn-primary goBack">'+getLiteral(dict.back)+'</button> \
					</div> \
				</div> \
			</div> \
		</div> \
	</div>';/*
	plotDashboardTemplate = '<table id="tablaDC" class="d-none table table-sm table-responsive table-striped m-0"> \
								<thead> \
									<tr> \
										{{#tdchead}} \
											{{{.}}} \
										{{/tdchead}} \
									</tr> \
									{{#haytdchead2}} \
									<tr> \
										{{#tdchead2}} \
											{{{.}}} \
										{{/tdchead2}} \
									</tr> \
									{{/haytdchead2}} \
								</thead> \
								<tbody> \
									{{#tdcrows}} \
										<tr>{{{.}}}</tr> \
									{{/tdcrows}} \
								</tbody> \
							</table>';*/
	coloresIfnTemplate =
	'<span class="ms-2" > \
		<button class="btn btn-sm border border-secondary" type="button" data-bs-toggle="dropdown" \
				aria-expanded="false" style="background-color: {{color}};"> \
			<i class="bi bi-droplet-fill"></i> \
		</button> \
		<ul id="ul_colores_{{ifn}}" class="dropdown-menu" aria-labelledby="dropdownMenu"> \
			{{#colores}} \
				<li><a class="dropdown-item color_ifn" href="#" ifn="{{ifn}}" cind="{{cind}}">{{label}}</a></li> \
			{{/colores}} \
		</ul> \
	</span>';
		
	/* TODO: previo
	plotDashboardTemplate = navbarTemplate +
	'<div class="container pb-4"> \
		<div class="container-fluid"> \
			<div class="row justify-content-lg-center mt-2 p-0"> \
				<div class="col-lg-9 p-0"> \
					<div class="card p-0"> \
						<div class="card-header pt-0 pb-1"> \
							<!--h5 class="col card-title my-0">{{{title}}}  <small>({{{source}}})</small></h5--> \
							<div class="d-flex justify-content-between my-2"> \
								<h5 class="card-title mt-2">{{{title}}}</h5> \
									<div class="btn-group ifnradioplot ms-sm-2 ms-1" role="group" aria-label="'+getLiteral(dict.ifnversion)+'" title="'+getLiteral(dict.ifnversion)+'"> \
									{{#ifns}} \
										{{#.}} \
										<input type="checkbox" class="btn-check check-ifn-dash" name="ifnradioplot" id="radioplot-{{ifn}}" piri="{{{piri}}}" autocomplete="off" {{#checked}}checked{{/checked}}> \
										<label class="btn btn-outline-secondary px-2" for="radioplot-{{ifn}}">{{label}}</label> \
										{{/.}} \
									{{/ifns}} \
									</div> \
							</div> \
							<table class="table table-borderless table-sm m-0" style="background-color: transparent;"> \
								<tbody style="background-color: transparent;"> \
									{{#rows}} \
										<tr> \
											<th scope="row" style="background-color: transparent;">{{{head}}}</th> \
											{{#els}} \
												<td style="background-color: transparent;">{{{.}}}</td> \
											{{/els}} \
										</tr> \
									{{/rows}} \
								</tbody> \
							</table> \
						</div> \
						<div class="card-body p-0"> \
							{{#hayMapa}} \
							<div id="mapaparcela" style="height: 450px;"></div> \
							{{/hayMapa}} \
							{{^hayMapa}} \
							<h5 class="text-center m-3 text-danger">'+getLiteral(dict.noTreesInPlot)+'</h5> \
							{{/hayMapa}} \
						</div> \
					</div> \
				</div> \
			</div> \
			<div class="row justify-content-lg-center"> \
				<div class="col-lg-9 py-4 px-0"> \
					<!-- TABLA árboles --> \
					{{#hayMapa}} \
					<div class="dropdown d-flex justify-content-between"> \
						<h5>'+getLiteral(dict.treeData)+'</h5> \
						<button id="botonTablaArboles" class="btn btn-secondary" type="button" data-bs-toggle="collapse" \
							data-bs-target="#tablaArboles" aria-expanded="false" aria-controls="tablaArboles">'+getLiteral(dict.show)+'</button> \
					</div> \
					<table id="tablaArboles" class="collapse table table-sm table-responsive table-striped m-0"> \
						<thead> \
							<tr> \
								{{#thead}} \
									{{{.}}} \
								{{/thead}} \
							</tr> \
							{{#haythead2}} \
							<tr> \
								{{#thead2}} \
									{{{.}}} \
								{{/thead2}} \
							</tr> \
							{{/haythead2}} \
						</thead> \
						<tbody> \
							{{#trows}} \
								<tr> \
									<th scope="row">{{{head}}}</th> \
									{{#els}} \
										<td>{{{.}}}</td> \
									{{/els}} \
								</tr> \
							{{/trows}} \
						</tbody> \
					</table> \
					{{/hayMapa}} \
					<!-- CANVAS infoSpeciesStock --> \
					{{#hayISS}} \
						{{#hayMapa}} \
						<hr> \
						{{/hayMapa}} \
					<h5>'+getLiteral(dict.stockSpeciesInfo)+'</h5> \
					<button id="botonInfoSpeciesStock" class="btn btn-secondary dropdown-toggle float-end" type="button" data-bs-toggle="dropdown" aria-expanded="false">'+getLiteral(dict.basalarea)+'</button> \
					<ul class="dropdown-menu"> \
						<li><a class="dropdown-item isstock" ind="0" href="#">'+getLiteral(dict.basalarea)+'</a></li> \
						<li><a class="dropdown-item isstock" ind="1" href="#">'+getLiteral(dict.treedensity)+'</a></li> \
						<li><a class="dropdown-item isstock" ind="2" href="#">'+getLiteral(dict.volumewithbark)+'</a></li> \
						<li><a class="dropdown-item isstock" ind="3" href="#">'+getLiteral(dict.volumewithoutbark)+'</a></li> \
					</ul> \
					<canvas id="speciesStockChart"></canvas> \
					{{/hayISS}} \
					<!-- CANVAS infoSpeciesDC --> \
					{{#hayDC}} \
						{{#hayISS}} \
						<hr> \
						{{/hayISS}} \
					<h5>'+getLiteral(dict.dcSpeciesInfo)+'</h5> \
					<div class="d-flex justify-content-between"> \
						{{#unaEspecieDC}} \
						<h5 class="mb-0">{{especieDCini}} \
						{{#iriEspecieDCini}} \
						<button id="botonInfoEspecieDC" class="btn" type="button" turi="{{{.}}}"> \
							<i class="bi bi-info-circle-fill"></i> \
						</button> \
						{{/iriEspecieDCini}} \
						</h5> \
						{{/unaEspecieDC}} \
						{{^unaEspecieDC}} \
						<div class="btn-group" role="group" aria-label="botonEspecieDC"> \
							<div class="btn-group" role="group"> \
								<button id="botonEspecieDC" class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">{{especieDCini}}</button> \
								<ul class="dropdown-menu"> \
									{{#especiesDC}} \
										<li><a class="dropdown-item idcesp" {{#turi}}turi="{{{.}}}"{{/turi}} href="#">{{label}}</a></li> \
									{{/especiesDC}} \
								</ul> \
							</div> \
							<button id="botonInfoEspecieDC" class="btn btn-secondary" type="button" turi="{{{iriEspecieDCini}}}" {{^iriEspecieDCini}}disabled{{/iriEspecieDCini}}> \
								<i class="bi bi-info-circle-fill"></i> \
							</button> \
						</div> \
						{{/unaEspecieDC}} \
						<button id="botonMedidaDC" ind="0" class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">'+getLiteral(dict.basalarea)+'</button> \
						<ul class="dropdown-menu"> \
							<li><a class="dropdown-item idcmed" ind="0" href="#">'+getLiteral(dict.basalarea)+'</a></li> \
							<li><a class="dropdown-item idcmed" ind="1" href="#">'+getLiteral(dict.treedensity)+'</a></li> \
							<li><a class="dropdown-item idcmed" ind="2" href="#">'+getLiteral(dict.volumewithbark)+'</a></li> \
							<li><a class="dropdown-item idcmed" ind="3" href="#">'+getLiteral(dict.volumewithoutbark)+'</a></li> \
						</ul> \
					</div> \
					<canvas id="speciesDCChart"></canvas> \
					{{/hayDC}} \
					<!-- BACK AND DELETE BUTTONS --> \
					<div class="float-end mt-3"> \
						<button type="button" class="btn btn-primary goBack">'+getLiteral(dict.back)+'</button> \
					</div> \
				</div> \
			</div> \
		</div> \
	</div>';*/

	
	alertQuestionnaireTemplate =
	'<div id="questalert" class="alert alert-secondary ms-2 mb-4 ms-md-4 p-2 alert-dismissible fade show text-center" role="alert"> \
		<p class="my-0"><h6>'+getLiteral(dict.questtext)+'</h6></p> \
		<button id="questbotlater" type="button" class="btn btn-secondary">'+getLiteral(dict.later)+'</button>\
		<button id="questbotno" type="button" class="btn btn-secondary mx-2">'+getLiteral(dict.no)+'</button>\
		<button id="questbotyes" type="button" questurl="'+getLiteral(dict.questurl)+'" class="btn btn-secondary">'+getLiteral(dict.yes)+'</button>\
	</div>';
}

export { cardTemplate, filtroTaxonesTemplate, taxonesSubheadingTemplate, sugeTaxonesTemplate, taxonesBlockTemplate, 
	sugeLugaresTemplate, filterPlotModalTemplate, taxonModalTemplate, provPopupTemplate, patchPopupTemplate, 
	plotPopupTemplate, footerFilterPlot, treePopupTemplate, 
	layerGroupTemplate,
	downloadTemplateBody, downloadingTemplateBody, footerDescargaDatos, footerDescargando, footerDescargaDatosExito,
	spinnerTemplate, plotDashboardTemplate, coloresIfnTemplate, alertQuestionnaireTemplate, updateHTMLtemplates };